import React from "react";
import { getModifiedKPIName, renderColorfulLegendText, CustomLabelList, formatValue } from "../utils/utils";
import appConstants from "../../../../../appConstants";
const [Planning, Dispatch] = appConstants.MODULES;
import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  BarChart,
  Bar,
  CartesianGrid,
  Tooltip,
  LabelList,
  Legend,
} from "recharts";
import chartConfig from "../ChartConfig";

const CustomBarChart = (props) => {
  return (
    <ResponsiveContainer>
      <BarChart
        onClick={props.onclick}
        data={props.data}
        margin={{
          top: 25,
          right: 5,
          left: 10,
          bottom: 10,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={props.chartConfig.Xkey} type="category" tickLine={false} />
        {props.chartConfig.chartlable1 === "Empty Time"
          ? <YAxis tickFormatter={props.toPercent} />
          : <YAxis />
        }
        <Tooltip formatter={formatValue} wrapperStyle={{color: chartConfig.chartColors.customLabel}}/>
        <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '40px' }} formatter={renderColorfulLegendText}/>

        {/* plotting bar chat for planning module data based on checkbox selection */
        props.checked?.isPlanningChecked &&
          <Bar
            dataKey={`${Planning}_${props.chartConfig.dataKey1}`}
            name={getModifiedKPIName(props.chartConfig.chartlable1, Planning)}
            fill={chartConfig.chartColors.planning.color}
          >
            {props.chartConfig.title !== "Routes Empty Time" &&
              <LabelList dataKey={props.chartConfig.Xkey} content={CustomLabelList} chartConfig={props.chartConfig}/>
            }
          </Bar>
        }

        {/* plotting bar chat for dispatch module data based on checkbox selection */
        props.checked?.isDispatchChecked && props.data.length!==0 &&
          <Bar
            dataKey={`${Dispatch}_${props.chartConfig.dataKey1}`}
            name={getModifiedKPIName(props.chartConfig.chartlable1, Dispatch)}
            fill={chartConfig.chartColors.dispatch.color}
          >
            {props.chartConfig.title !== "Routes Empty Time" &&
              <LabelList dataKey={props.chartConfig.Xkey} content={CustomLabelList} chartConfig={props.chartConfig} />
            }
          </Bar>
        }
      </BarChart>
    </ResponsiveContainer>
  )
}

export default CustomBarChart;
